export default {
    namespaced: true,
    state: {
        has_got_map_config_from_server: false,
        map_config_from_server: {},

        // menu
        is_hide_menu: false,
        
        // product
        selected_products: [],
        config: {},
        keep_group_list: [],
        multiple_group_list: [],
        timeless_list: [],
        first_time_render: true, // 設定切換時的重新 render狀況使用

        // render 仰角回波
        radar: {
            id: '',
            angle: '',
            angle_options: [],
        },

        // render vertical radar 雷達回波 3D
        is_open_vertical_radar: false,

        // geojson alert
        is_show_alert_table: true,

        // geojson typhoon
        is_show_typhoon_time: true,
        is_show_typhoon_animation: true,

        // geojson accumulated_precp
        is_show_accumulated_precp_table: false, 
        accumlated_precp_id_list: [],

        // geojson monitor: for 回波警示表
        is_show_monitor_tooltip: true,

        // gis dropsonde
        dropsonde: {
            id: '',
            hPa: 'all',
        },

        // background
        selected_background_products: [],

        // time_choose
        time_choose_parameters: {
            status: 'newest',
            start_time_epoch: '',
            end_time_epoch: '',
        },

        // 自動更新
        current_time_epoch:'',
        is_timer_on: false,
        user_auto_update_setting: true,

        // for forecast product text
        // 時間軸
        current_timestamp: 0,
        selected_timeless_item_id: '',
        is_clear_all: false,

        accumulated_precp: {
            start_time: '',
            end_time: '',
        },

        // 所有 有自訂剖面功能的產品
        all_3D_products: [],
    },

    mutations:{
        set_is_hide_menu(state, new_is_hide_menu) {
            state.is_hide_menu = new_is_hide_menu
        },

        set_selected_products(state, new_selected_products) {
            state.selected_products = new_selected_products
        },

        set_first_time_render(state, new_first_time_render) {
            state.first_time_render = new_first_time_render
        },

        set_emap_special_feature_list(state, {config, keep_group_list, multiple_group_list, timeless_list}) {
            state.config = config
            state.keep_group_list = keep_group_list
            state.multiple_group_list = multiple_group_list
            state.timeless_list = timeless_list
        },
        
        set_selected_background_products(state, new_selected_background_products) {
            state.selected_background_products = new_selected_background_products
        },

        set_current_time_epoch(state, current_time_epoch) {
            state.current_time_epoch = current_time_epoch
        },
        
        set_map_config_from_server(state, map_config_from_server) {
            state.map_config_from_server = map_config_from_server
        },

        set_has_got_map_config_from_server(state, has_got_map_config_from_server) {
            state.has_got_map_config_from_server = has_got_map_config_from_server
        },

        set_timer_on(state, is_timer_on) {
            state.is_timer_on = is_timer_on;
        },

        set_is_clear_all(state, is_clear_all) {
            state.is_clear_all = is_clear_all
        },
        
        set_user_auto_update_setting(state, user_auto_update_setting) {
            state.user_auto_update_setting = user_auto_update_setting
        },

        set_current_timestamp(state, current_timestamp) {
            state.current_timestamp = current_timestamp
        },
        
        set_selected_timeless_item_id(state, selected_timeless_item_id) {
            state.selected_timeless_item_id = selected_timeless_item_id
        },
        
        set_is_open_vertical_radar(state, is_open_vertical_radar) {
            state.is_open_vertical_radar = is_open_vertical_radar
        },

        set_radar(state, radar) {
            state.radar = { ...state.radar, ...radar }
        },

        set_is_show_alert_table(state, is_show_alert_table) {
            state.is_show_alert_table = is_show_alert_table
        },

        set_is_show_typhoon_time(state, is_show_typhoon_time) {
            state.is_show_typhoon_time = is_show_typhoon_time
        },
        
        set_is_show_typhoon_animation(state, is_show_typhoon_animation) {
            state.is_show_typhoon_animation = is_show_typhoon_animation
        },

        set_is_show_accumulated_precp_table(state, is_show_accumulated_precp_table) {
            state.is_show_accumulated_precp_table = is_show_accumulated_precp_table
        },
    
        set_accumlated_precp_id_list(state, new_accumlated_precp_id_list) {
            state.accumlated_precp_id_list = new_accumlated_precp_id_list ?? []
        },
        
        set_accumulated_precp(state, new_accumulated_precp) {
            state.accumulated_precp = {
                ...state.accumulated_precp,
                ...new_accumulated_precp
            }
        },

        set_is_show_monitor_tooltip(state, is_show_monitor_tooltip) {
            state.is_show_monitor_tooltip = is_show_monitor_tooltip
        },

        set_dropsonde(state, new_dropsonde) {
            state.dropsonde = {
                ...state.dropsonde,
                ...new_dropsonde,
            }
        },

        set_time_choose_parameters(state, new_time_choose_parameters) {
            state.time_choose_parameters = {
                ...state.user_customized_time,
                ...new_time_choose_parameters
            }
        },

        set_all_3D_products(state, new_all_3D_products) {
            state.all_3D_products = new_all_3D_products
        }
    },
    actions: {          
    
    },
    getters: {
        timer_visible(state, getters, root_state) {
            const is_monitor = root_state.monitor.is_monitor
            const is_atlas = root_state.atlas.is_atlas
            const { status: map_time_status } = state.time_choose_parameters
            return map_time_status === 'newest' && !is_monitor && !is_atlas && !state.selected_timeless_item_id && !state.is_clear_all
        },
        
        user_auto_update_setting: state => state.user_auto_update_setting,
        radar_id: state => state.radar.id,
        radar_angle: state => state.radar.angle,
        radar_angle_options: state => state.radar.angle_options,
        dropsonde_hPa: state => state.dropsonde.hPa,
        map_status: state => state.time_choose_parameters.status,
    },
}